import { render, staticRenderFns } from "./ActivationCustomTaskDeliveryView.vue?vue&type=template&id=3da48e22&scoped=true&"
import script from "./ActivationCustomTaskDeliveryView.vue?vue&type=script&lang=js&"
export * from "./ActivationCustomTaskDeliveryView.vue?vue&type=script&lang=js&"
import style0 from "./ActivationCustomTaskDeliveryView.vue?vue&type=style&index=0&id=3da48e22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da48e22",
  null
  
)

export default component.exports